export default {
  getVeiculos({ veiculos }) {
    return veiculos
  },

  getSelectedVeiculo({ selectedVeiculo }) {
    return selectedVeiculo
  }
}
